import React from "react";

const DataProcessingPage = () => {
  return (
    <main className="container mx-auto px-4 py-8">
      <header className="mb-8">
        <h1 className="text-3xl font-bold">Сбор и обработка персональных данных</h1>
      </header>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">1. Общие положения</h2>
        <p className="mb-4">
          Настоящий документ определяет порядок сбора, хранения, обработки и защиты персональных данных, предоставляемых пользователями интернет-магазина «Vanil» (далее – Магазин). Используя наш сайт, вы подтверждаете свое согласие с настоящими условиями.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">2. Сбор и обработка данных</h2>
        <p className="mb-4">
          Мы собираем следующую информацию:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Фамилия, имя, отчество;</li>
          <li>Контактный телефон и адрес электронной почты;</li>
          <li>Адрес доставки и платежные реквизиты;</li>
          <li>История покупок и взаимодействия с сайтом.</li>
        </ul>
        <p className="mb-4">
          Данные собираются через формы регистрации, оформления заказов и обратной связи. Обработка данных осуществляется в соответствии с требованиями законодательства Республикой Казахстан.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">3. Цели обработки данных</h2>
        <p className="mb-4">
          Персональные данные используются для:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Оформления и доставки заказов;</li>
          <li>Предоставления клиентской поддержки;</li>
          <li>Информирования о новинках, акциях и специальных предложениях;</li>
          <li>Проведения маркетинговых исследований и анализа предпочтений покупателей.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">4. Права субъектов персональных данных</h2>
        <p className="mb-4">
          Вы имеете право:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Получать информацию о своих персональных данных, хранящихся у нас;</li>
          <li>Требовать уточнения, обновления или удаления своих данных;</li>
          <li>Ограничивать обработку своих данных;</li>
          <li>Отозвать свое согласие на обработку персональных данных.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">5. Меры безопасности</h2>
        <p className="mb-4">
          Мы применяем необходимые технические и организационные меры для защиты ваших данных от несанкционированного доступа, утраты, изменения или распространения.
        </p>
      </section>
    </main>
  );
};

export default DataProcessingPage;
